import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../services/AuthContext'; 

const UserIcon = () => (
    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"></path></svg>
);

const MenuIcon = () => (
    <svg className="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16M4 18h16"></path></svg>
);

const AdminIcon = () => (
    <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
);

export const Header = ({ onMenuButtonClick }) => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    logout();
    navigate('/'); // Redirigir a la página principal (Quiénes Somos) después del logout
  };

  return (
    <header className="sticky top-0 z-30 bg-gob-azul-oscuro border-b border-white/10 w-full h-16 flex items-center">
      <div className="w-full flex justify-between items-center px-2 sm:px-4">
        {/* Botón de Menú (hamburguesa) */}
        <button 
          onClick={onMenuButtonClick} 
          className="p-2 rounded-md hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white" 
          aria-label="Abrir menú"
        >
            <MenuIcon />
        </button>

        {/* Área central vacía - solo controles en los extremos */}
        <div className="flex-1"></div>

        <div className="flex items-center gap-2">
          {user ? (
            <>
              {/* Enlace de administración - solo visible para usuarios logueados */}
              <Link
                to="/admin"
                className={`p-2 rounded-md text-white hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white transition-all duration-200 ${
                  location.pathname === '/admin' ? 'bg-white/20' : ''
                }`}
                aria-label="Panel de administración"
                title="Panel de administración"
              >
                <AdminIcon />
              </Link>
              
              <span className="font-medium text-sm text-white">
                {`${user.first_name} ${user.last_name}`}
              </span>
              <button
                onClick={handleLogout}
                className="p-2 rounded-md text-white hover:bg-gob-rojo focus:outline-none focus:ring-2 focus:ring-white"
                aria-label="Cerrar sesión"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"></path></svg>
              </button>
            </>
          ) : (
            <Link 
              to="/login"
              className="flex items-center gap-2 p-2 rounded-md hover:bg-white/20 focus:outline-none focus:ring-2 focus:ring-white" 
              aria-label="Iniciar sesión"
            >
              <UserIcon />
              <span className="hidden sm:inline text-sm text-white">Iniciar sesión</span>
            </Link>
          )}
        </div>
      </div>
    </header>
  );
};

export default Header;